/**
 * The admin nav's badges. The shell reads them in one call (`GET /api/admin/counts`); an API from before that route
 * answers 404, and then the two badges it can still count come from the alerts and waitlist calls. Pure.
 */
import type { AdminCounts, AlertList, WaitlistEntry } from './schemas'

/** What the badges can show without the counts route: open unacknowledged alerts and people not yet invited. */
export function fallbackCounts(alerts: AlertList | null | undefined, waitlist: WaitlistEntry[] | null | undefined): Partial<AdminCounts> {
  const out: Partial<AdminCounts> = {}
  if (alerts) out.alertsOpen = alerts.counts.unacknowledged
  if (waitlist) out.waitlist = waitlist.filter((w) => !w.invited).length
  return out
}

/** True when the API has no counts route yet, so the shell should fall back. */
export const countsMissing = (error: Error | undefined) => (error as { status?: unknown } | undefined)?.status === 404
